import { useMemo } from 'react';

export const useAbTests = () => {
  // TODO: this is no longer an a/b test, clean this up in search-api
  return useMemo(() => ['restrict-designers-to-us', 'sort-batch-final'], []);
};
